// extracted by mini-css-extract-plugin
module.exports = {"content":"Documentation_content__xAHMP"};